export default __webpack_public_path__ + "static/media/primary-desktop.ab9959d5.png";